<template>
  <svg width="23"
       height="23"
       viewBox="0 0 23 23"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.3281 16.6685L11.9966 20L8.66516 16.6685M6.99942 5.00833L6.99942 5M6.99942 7.49861L6.99942 7.49028M7.83229 9.98889L7.83229 9.98057M10.3309 11.6463L10.3309 11.638"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5" />
    <path
      d="M11.9969 20L11.9969 15.5075C11.9969 14.5837 12.2249 13.6742 12.6608 12.8597C13.0966 12.0451 13.7269 11.3509 14.4955 10.8384C15.2642 10.326 15.8944 9.6317 16.3303 8.81719C16.7662 8.00268 16.9942 7.09315 16.9941 6.16935L16.9941 5.00833"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "white"
    }
  }
}
</script>
